var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelerik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150v150H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8 45.2L41.9 11.3 8 45.2l13.4 13.4 20.5-20.5 20.5 20.5-33.9 33.9 47.3 47.3 47.4-47.4-34-33.9 20.3-20.3L130 58.7l13.4-13.4-33.9-33.9-33.7 33.8zm20.4 47.3L75.7 113 55.3 92.5 75.8 72l20.4 20.5z",
    fill: "#49e900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelerik);
export default __webpack_public_path__ + "static/media/telerik.6e0e8e6ffdddd21ee07e6f47d416fbff.svg";
export { ForwardRef as ReactComponent };